<template>
    <TemplateClient :subtitle="$t('client.visual_content.title')">

        <p>Contenu en cours de développement</p>

    </TemplateClient>
</template>

<script>
import TemplateClient from '@/components/templates/TemplateClient';
import { mapState } from 'vuex';

export default {
    name: 'ClientImages',
    components: {TemplateClient},
    computed: {
        ...mapState(['client'])
    }
}
</script>
